import { render } from "./PolicyPage.vue?vue&type=template&id=67dcfbd0"
import script from "./PolicyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__